import { useLayoutEffect, useRef } from 'react';

function updateHeight(element: HTMLTextAreaElement) {
  element.style.height = 'auto';
  element.style.height = `${element.scrollHeight}px`;
}

export interface UseAutoExpandOptions {
  enabled?: boolean;
}

export function useAutoExpand(options?: UseAutoExpandOptions) {
  const elementRef = useRef<HTMLTextAreaElement>(null);

  const enabled = options?.enabled ?? true;

  useLayoutEffect(() => {
    if (!enabled) return;

    const element = elementRef.current;
    if (!element) return;

    updateHeight(element);
    const listener = () => updateHeight(element);
    element.addEventListener('input', listener);
    return () => {
      element.removeEventListener('input', listener);
    };
  }, [enabled]);

  return elementRef;
}
